var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1758 7.17951C17.4353 6.3341 17.0272 5.2484 17.0275 4.12451H13.68V17.5578C13.6542 18.2848 13.3473 18.9734 12.8239 19.4785C12.3005 19.9837 11.6016 20.2661 10.8742 20.2662C9.33582 20.2662 8.05749 19.0095 8.05749 17.4495C8.05749 15.5862 9.85582 14.1887 11.7083 14.7628V11.3395C7.97082 10.8412 4.69916 13.7445 4.69916 17.4495C4.69916 21.057 7.68916 23.6245 10.8633 23.6245C14.265 23.6245 17.0275 20.862 17.0275 17.4495V10.6353C18.3849 11.6102 20.0146 12.1332 21.6858 12.1303V8.78285C21.6858 8.78285 19.6492 8.88035 18.1758 7.17951Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.9a34ac60c239622237247d95664740e0.svg";
export { ForwardRef as ReactComponent };